export default __webpack_public_path__ + "static/media/2-secs-lambo-crypto.c5e17c3a.jpeg";